import React from "react"

import FieldProto_ConditionForm from "../../../../proto/render/condition/condition-form"
import ConditionTypeSelector from "../../../../proto/render/condition/condition-type-selector"
import SelectMultiGenericNew from "../../../../../gd-ui/select-multi-generic-new/select-multi-generic-new"
import FieldRag_MultiselectPopoverOption from "../../components/multiselect/popover-option";
import FieldRag_MultiselectValueNotEmpty from "../../components/multiselect/value-not-empty";

const debug = false
// const debug = "FieldRAG_ConditionForm"

export default class FieldRAG_ConditionForm extends FieldProto_ConditionForm {

    render() {
        debug && console.log(debug, 'render', this.state)

        return (
            <React.Fragment>
                <ConditionTypeSelector field    = {this.props.field}
                                       value    = {this.props.condition.type}
                                       onChange = {this.onChangeType}/>

                <SelectMultiGenericNew className                        = "selector w-250 m-l-10"
                                       options                          = {this.props.field.getOptions()}
                                       values                           = {this.props.condition.value}
                                       popoverScrollContainerClasses    = "max-h-200 max-w-300"
                                       valueComponent                   = {FieldRag_MultiselectValueNotEmpty}
                                       popoverOptionComponent           = {FieldRag_MultiselectPopoverOption}
                                       isSearchable                     = {true}
                                       // disabled                         = {disabled}
                                       onChange                         = {this.onChangeValue}/>
            </React.Fragment>
        )
    }
}
